import React from 'react';
import {Modal, Text, FlexColumn, FlexRow, Frame, SubHeading} from '@forecast-it/design-system';
import {FormattedMessage, useIntl} from 'react-intl';
import {ExpenseRow} from './ExpenseTypes';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import DeleteExpenseItemMutation from '../../mutations/delete_expense_item_mutation';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';

type ExpenseManagementModalProps = {
	selectedRow: ExpenseRow;
	companyId: string;
	closeModal: () => void;
};

const DeleteExpenseModal = ({selectedRow, companyId, closeModal}: ExpenseManagementModalProps): JSX.Element => {
	const {formatMessage} = useIntl();

	const onDelete = () => {
		const onSuccess = () => {
			closeModal();
			createToast({duration: 5000, message: formatMessage({id: 'expense_item.has_been_deleted'})});
		};
		Util.CommitMutation(
			DeleteExpenseItemMutation,
			{
				id: selectedRow.id,
				companyId,
				projectId: selectedRow.project?.id,
				companyProjectId: selectedRow.project?.companyProjectId,
			},
			onSuccess
		);

		trackEvent('Expense Actions Delete', 'Clicked', {expenseId: selectedRow.id});
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id="expense_management.modal.delete_expense" />
			</Modal.Title>
			<Modal.Content>
				<FlexColumn gap={'xxl'}>
					<FlexRow>
						<Text>
							<FormattedMessage id="expense_management.modal.are_you_sure_delete_expense" />
						</Text>
					</FlexRow>
					<Frame>
						<FlexRow gap={'xl'}>
							<FlexColumn flex={'none'} gap={'s'}>
								<Text>{formatMessage({id: 'expense_management.modal.expense_name'})}</Text>
								<Text>{formatMessage({id: 'expense_management.modal.project_name'})}</Text>
							</FlexColumn>
							<FlexColumn gap={'s'}>
								<SubHeading ellipsis>{selectedRow.name}</SubHeading>
								<SubHeading ellipsis>{selectedRow.project?.name}</SubHeading>
							</FlexColumn>
						</FlexRow>
					</Frame>
				</FlexColumn>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onDelete}>
					<FormattedMessage id="expense_management.modal.delete_expense" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.cancel'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteExpenseModal;
